(ns ballot-scout-v2-frontend.components.upload
  (:require
   [reagent.core :as r]))

#_:clj-kondo/ignore
(defn upload-file
  "Returns a form 2 component that allows user to drag or browse to upload a file.
   Takes a subscription `upload-sub` which can be dereffed to retreive the status of the upload.
   Also takes an `upload-file-fn` which takes a file object and does something with it, presumaby
   changing the value of the subscription `upload-file`."
  [upload-sub upload-file-fn content]
  (let [enabled? (r/atom true)
        drag-over? (r/atom false)
        file (r/atom nil)]
    (fn [upload-sub upload-file-fn]
      [:div {:class "is-centered columns"}
       [:div {:class (str "column is-two-thirds-desktop upload-stage"
                          (when @drag-over?
                            " dragover box")
                          (when (:error-response @upload-sub)
                            " p-0"))
              :on-drag-over #(.preventDefault %)
              :on-drag-enter #(when @enabled? (reset! drag-over? true))
              :on-drag-leave #(reset! drag-over? false)
              :on-drop (fn [e]
                         (.preventDefault e)
                         (reset! drag-over? false)
                         (when @enabled?
                           (reset! file (-> e .-dataTransfer .-files (aget 0)))))}
        (cond
          (:error-response @upload-sub) ;; show error state
          [:div {:class "notification is-danger is-light p-5"}
           [:h3 "Error Uploading File"]
           [:strong (:error-response @upload-sub)]]

          (= :uploading (:status @upload-sub)) ;; show loading state
          [:div {:class "loading py-6 has-text-centered"}
           [:img.centered-img {:src "/images/compass-100x100.png"}]
           [:div {:class "pt-3 has-text-grey-dark is-size-6"} "Uploading file..."]]

          (and @file (not @drag-over?)) ;; display file submission form
          [:div
           [:div {:class "pt-5 has-text-centered"}
            "Upload "
            [:span {:class "is-italic has-text-weight-bold"}
             (.-name @file)]
            " to Ballot Scout?"]
           [:div {:class "py-5 has-text-centered"}
            [:span {:class "px-1"}
             [:button {:class "button is-primary"
                       :type "submit"
                       :on-click #(do (reset! enabled? false) (upload-file-fn @file))}
              "Upload File"]]
            [:span {:class "px-1"}
             [:button {:class "button"
                       :on-click #(reset! file nil)}
              "Start Over"]]]]

          :else ;; display file selector
          [:div
           [:div {:class "has-text-centered has-text-weight-bold"}
            [:div {:class "py-5"}
             [:span {:class "icon is-large"}
              ;; todo: refactor to use icon component
              [:i {:class (str "fa fa-upload fa-3x"
                               (when @drag-over?
                                 " has-text-primary"))}]]]
            [:label {:for "import-upload"}
             [:input {:id "import-upload" :class "is-hidden" :type "file" :name "files[]"
                      :accept "text/csv, .csv, text/plain, .txt"
                      :on-change (fn [e]
                                   (.preventDefault e)
                                   (reset! drag-over? false)
                                   (reset! file (-> e .-target .-files (aget 0))))}]
             [:div {:class "pb-5"}
              [:a (if @file "Choose a new file" "Choose file")]
              [:span " or drag and drop to upload"]]]]
           [:div {:class "content pb-5"}
            content]])]])))
